export const measureTimeToEdit = (triggerAnalyticsEvent: Function): void => {
	// log time of keypress
	const now: number = performance?.now();

	// grab the array of fmp & tti metrics
	const fmpMetrics: PerformanceEntryList = performance?.getEntriesByName('browser-metric:fmp');
	const ttiMetrics: PerformanceEntryList = performance?.getEntriesByName('browser-metric:tti');

	// grab the most recently added fmp & tti metrics
	const fmpEnd: number =
		fmpMetrics[fmpMetrics.length - 1]?.startTime + fmpMetrics[fmpMetrics.length - 1]?.duration;
	const ttiEnd: number =
		ttiMetrics[ttiMetrics.length - 1]?.startTime + ttiMetrics[ttiMetrics.length - 1]?.duration;

	// if now (keypress time), fmp, and tti all exist, fire the measure time to edit analytics event
	if (now && fmpEnd && ttiEnd) {
		triggerAnalyticsEvent('measure.time.to.edit', {
			keypressTime: now,
			fmpTimeToEdit: now - fmpEnd,
			ttiTimeToEdit: now - ttiEnd,
			fmpEnd,
			ttiEnd,
		});
	}
};
